module.exports = __webpack_public_path__ + "img/paint1.01e68c63.png";